export default "__VITE_ASSET__CAubCuDd__"